import "./FlagDropDown.scss";
import { forwardRef, useMemo, ForwardedRef, MouseEvent } from "react";
// import FeatherIcon from "@common/FeatherIcon";
import imgFlagEnUs from "../../../assets/images/flags/en-us.jpg";
import imgFlagHyAm from "../../../assets/images/flags/hy-am.jpg";
import imgFlagRuRu from "../../../assets/images/flags/ru-ru.jpg";
import { useTranslation } from "react-i18next";

// interface PropsTypeInterface {
//     opened: boolean;
//     onLangClick: (e: MouseEvent<HTMLDivElement>) => void;
// }

// interface LangInterface {
//     language: string;
//     flagImage: string;
//     text: string;
// }

const languages = [
    {
        language: "AM",
        flagImage: imgFlagHyAm,
        text: "Հայերեն",
    },
    {
        language: "RU",
        flagImage: imgFlagRuRu,
        text: "Русский",
    },
    {
        language: "EN",
        flagImage: imgFlagEnUs,
        text: "English",
    },
];

const FlagDropDown = forwardRef(function (props, ref) {
    const { i18n } = useTranslation();

    const activeLanguage = useMemo(() => {
        const activeLanguage = languages.find((lang) => lang.language == i18n.language);
        if (!activeLanguage) {
            return languages[0];
        }

        return activeLanguage;
    }, [i18n.language]);

    return (
        <div className="FlagDropDown">
            <img draggable={false} src={activeLanguage.flagImage} />

            <div className="FlagDropDownArrow">
                {/* <FeatherIcon icon="chevron-down" size={18} /> */}
                <i className="mdi mdi-chevron-down"></i>
            </div>

            {props.opened && (
                <div className="FlagDropDownContent" ref={ref}>
                    <div className="FlagDropDownContent-TriangleBack" />
                    <div className="FlagDropDownContent-TriangleFront" />

                    <div className="FlagDropDownContent-Container">
                        {languages.map((language) => (
                            <div
                                className="FlagDropDownContent-Row"
                                onClick={props.onLangClick}
                                data-lang={language.language}
                            >
                                <div className="FlagDropDownContent-RowIcon">
                                    <img draggable={false} src={language.flagImage} />
                                </div>
                                <div className="FlagDropDownContent-RowText">{language.text}</div>

                                {i18n.language == language.language && (
                                    <div className="FlagDropDownContent-RowCheck">
                                        {/* <FeatherIcon icon="check" size={16} strokeWidth="3px" color="green" /> */}
                                        <i className="mdi mdi-check"></i>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
});

export default FlagDropDown;
